export const SET_CONNECTIONS = 'SET_CONNECTIONS';
export const SET_CONNECTIONS_CACHE = 'SET_CONNECTIONS_CACHE';
export const SET_CONNECTION_CONFIG = 'SET_CONNECTION_CONFIG';
